import { createAction } from "@reduxjs/toolkit";

export const getAvailableItemsAction = createAction("models/items");
